module.exports = __webpack_public_path__ + "img/DF_cell_illustration_mobile.7af77d13.jpg";